import { useEffect, useRef, useState } from 'react'
import { Loader2, XCircle } from 'lucide-react'
import { api } from '../utils/api'

interface Props {
  onLogin: (user: { username: string; role: string }) => void
}

export default function SsoCallbackPage({ onLogin }: Props) {
  const [error, setError] = useState('')
  const ran = useRef(false)

  useEffect(() => {
    if (ran.current) return
    ran.current = true
    const token = new URLSearchParams(window.location.search).get('token')
    if (!token) { setError('ไม่พบ token จากการเข้าสู่ระบบ'); return }
    localStorage.setItem('token', token)
    api.get('/auth/me')
      .then(r => onLogin(r.data))
      .catch(() => {
        localStorage.removeItem('token')
        setError('เข้าสู่ระบบไม่สำเร็จ กรุณาลองใหม่')
      })
  }, [onLogin])

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-8 text-center">
        {error ? (
          <>
            <XCircle size={32} className="text-red-500 mx-auto mb-3"/>
            <p className="text-sm text-gray-700 mb-4">{error}</p>
            <a href="/login" className="text-sm text-blue-600 hover:underline">กลับไปหน้าเข้าสู่ระบบ</a>
          </>
        ) : (
          <>
            <Loader2 size={32} className="text-blue-600 mx-auto mb-3 animate-spin"/>
            <p className="text-sm text-gray-500">กำลังเข้าสู่ระบบด้วย Microsoft...</p>
          </>
        )}
      </div>
    </div>
  )
}
